import { render, staticRenderFns } from "./text.vue?vue&type=template&id=58c74ee7&"
import script from "./text.vue?vue&type=script&lang=ts&"
export * from "./text.vue?vue&type=script&lang=ts&"
import style0 from "./text.vue?vue&type=style&index=0&id=58c74ee7&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports